import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "./firebase";
import { v4 as uuidv4 } from "uuid";
import { Timestamp } from "firebase/firestore";

const COGNITIVE_TEST_KEY = "braincheck_cognitive_id";

// 로컬 스토리지에서 사용자 ID 가져오기
export const getCognitiveTestId = (): string | null => {
  return localStorage.getItem(COGNITIVE_TEST_KEY);
};

// 로컬 스토리지에 사용자 ID 저장
export const setCognitiveTestId = (testId: string): void => {
  localStorage.setItem(COGNITIVE_TEST_KEY, testId);
};

export const generateTestId = (): string => {
  return uuidv4();
};

export const getCognitiveTestSetId = (): string | null => {
  return localStorage.getItem("cognitiveTestSetId");
};

export const setCognitiveTestSetId = (id: string): void => {
  localStorage.setItem("cognitiveTestSetId", id);
};

export const clearCognitiveTestSetId = (): void => {
  localStorage.removeItem("cognitiveTestSetId");
};

export const generateTestSetId = (): string => {
  const timestamp = Timestamp.now().toMillis();
  const random = Math.random().toString(36).substring(2, 8);
  return `${timestamp}_${random}`;
};
